import React from 'react';
import bgImage from '../../assets/servicesImages/devops/hero.png';
import arrow from '../../assets/viewdetails.png';
import pic1 from '../../assets/servicesImages/devops/1.png';
import pic2 from '../../assets/servicesImages/devops/2.png';
import pic3 from '../../assets/servicesImages/devops/3.png';
import pic4 from '../../assets/servicesImages/devops/4.png';
import Slider from 'react-slick';
import icon1 from '../../assets/servicesImages/devops/icon1.png';
import icon2 from '../../assets/servicesImages/devops/icon2.png';
import icon3 from '../../assets/servicesImages/devops/icon3.png';
import a from '../../assets/servicesImages/devops/a.png';
import b from '../../assets/servicesImages/devops/b.png';
import c from '../../assets/servicesImages/devops/c.png';

const item = [
  {
    icon: icon1,
    title: 'Discovery & Analysis',
    desc: 'We begin with a deep discovery phase, assessing your infrastructure and business goals to tailor a strategic cloud roadmap.',
  },
  {
    icon: icon2,
    title: 'Feasibility & Planning',
    desc: 'Next, we evaluate cloud feasibility and develop a step-by-step migration plan aligned with your operations.',
  },
  {
    icon: icon3,
    title: 'Architecture Design',
    desc: 'Our engineers create a secure, scalable cloud design using AWS, Azure, or Google Cloud tailored to your business needs.',
  },
];

const settings = {
  className: 'center',
  centerMode: true,
  infinite: true,
  slidesToShow: 4,
  speed: 500,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
        breakpoint: 3000, // large screens default
        settings: {
            slidesToShow: 4,
        },
    },
    {
        breakpoint: 1024, // md to lg
        settings: {
            slidesToShow: 2.5,
            centerMode: false,
        },
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 2,
            centerMode: false,
        }
    },
    {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            centerMode: false,
        }
    }
]
};

const settings2 = {
  className: 'center',
  centerMode: true,
  infinite: true,
  slidesToShow: 3,
  speed: 500,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
        breakpoint: 3000, // large screens default
        settings: {
            slidesToShow: 4,
        },
    },
    {
        breakpoint: 1024, // md to lg
        settings: {
            slidesToShow: 2.5,
            centerMode: false,
        },
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 2,
            centerMode: false,
        }
    },
    {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            centerMode: false,
        }
    }
]
};

const cards = [
  {
    image: pic1,
    tile: 'CI/CD Automation',
    point1: 'Automate your build, test, and deployment pipelines.',
    point2: 'Reduce errors and speed up time-to-market.',
    point3: 'Ensure high-quality code with continuous integration.',
  },
  {
    image: pic2,
    tile: 'Infrastructure as Code (IaC)',
    point1: 'Provision infrastructure using code.',
    point2: 'Consistency and scalability ensured.',
    point3: 'Tools: Terraform, Ansible, CloudFormation.',
  },
  {
    image: pic3,
    tile: 'Monitoring & Logging',
    point1: 'Get real-time system insights.',
    point2: 'Use logging to troubleshoot quickly.',
    point3: 'Proactive monitoring boosts reliability.',
  },
  {
    image: pic4,
    tile: 'Cloud Services & Migration',
    point1: 'Optimize and manage cloud infrastructure.',
    point2: 'Migrate to AWS, Azure, or Google Cloud.',
    point3: 'Leverage cloud-native scalability.',
  },
];

const DevOps = () => {
  return (
    <div className="flex flex-col gap-24 text-gray-800">
      {/* Hero Section */}
      <div className='h-[40vh] md:h-[50vh] lg:h-screen w-full text-white flex justify-start items-center pt-24 relative bg-cover bg-center'

        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="absolute inset-0 bg-[rgba(0,0,0,0.45)] z-0"></div>
        <div className="z-10 px-10 md:px-28 flex flex-col gap-12">
          <h1 className="text-4xl md:text-5xl font-bold leading-tight">
            DevOps Services
          </h1>
          <p className="text-lg md:w-[500px]">
            Transform Your Development and Operations with Our Expert DevOps Solutions
          </p>
        </div>
      </div>

      {/* Introduction */}
      <div className="px-4 sm:px-6 md:px-28 text-justify flex flex-col gap-4 sm:gap-6">
  <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-center">
    Transform Your Development & Operations
  </h2>
  <p className="text-sm sm:text-base md:text-lg text-gray-600">
    In today’s fast-paced digital world, our DevOps services bridge the gap between development and operations,
    delivering seamless, automated, and robust solutions for efficiency and scalability.
  </p>
</div>


      {/* Services Carousel */}
      <div className="px-6 md:px-10">
        <h3 className="text-3xl font-bold text-center mb-10">Our DevOps Services Include:</h3>
        <Slider {...settings}>
          {cards.map((card, i) => (
            <div key={i} className="p-4 group">
              <div className="bg-white shadow-xl hover:shadow-2xl transition-all duration-300 rounded-lg overflow-hidden p-5 h-[460px] flex flex-col justify-between hover:scale-[1.02] hover:text-blue-900">
                <img src={card.image} alt="service" className="mb-4 rounded" />
                <h4 className="text-lg font-semibold text-center text-gray-800 group-hover:text-blue-700 transition-colors">
                  {card.tile}
                </h4>
                <ul className="text-sm text-gray-700 list-disc pl-5 space-y-2 mt-4">
                  <li>{card.point1}</li>
                  <li>{card.point2}</li>
                  <li>{card.point3}</li>
                </ul>
                <div className="text-blue-600 text-sm flex items-center justify-end mt-4 hover:underline">
                  <a href="/">View Details</a>
                  <img src={arrow} alt="arrow" className="w-4 ml-1" />
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {/* Cloud Engineering Journey */}
      <div className="px-4 sm:px-6 md:px-28 flex flex-col gap-4 sm:gap-6 text-justify">
  <h3 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-center">
    Our Cloud Engineering Journey
  </h3>
  <p className="text-sm sm:text-base md:text-lg text-gray-600">
    Our Cloud Engineering process ensures a seamless transition with strategic planning and technical excellence
    tailored to your goals.
  </p>
</div>


      <div className="px-6 md:px-10">
        <Slider {...settings2}>
          {item.map((item, i) => (
            <div key={i} className="p-4 group">
              <div className="bg-white border shadow-xl hover:shadow-2xl transition-shadow duration-300 rounded-lg p-6 h-[340px] flex flex-col items-center text-center hover:scale-[1.03] hover:text-blue-800">
                <img src={item.icon} alt="icon" className="w-[60px] h-[60px] mb-4" />
                <h4 className="font-bold text-lg mb-2">{item.title}</h4>
                <p className="text-sm text-gray-600">{item.desc}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {/* Cloud Advantage */}
      <div className="px-4 sm:px-6 md:px-28 flex flex-col gap-4 sm:gap-6 text-justify">
  <h3 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-center">
    Our Cloud Expertise Advantage
  </h3>
  <p className="text-sm sm:text-base md:text-lg text-gray-600">
    Esparse Matrix Solutions enables businesses to fully leverage cloud technology for speed, reliability, and performance.
  </p>
</div>


      <div className="bg-[#EAEEFB] py-16 px-6 md:px-28 grid grid-cols-1 md:grid-cols-3 gap-10">
      <div className="flex flex-col items-center gap-4 text-center shadow-md hover:shadow-lg p-4 rounded-lg transition-shadow duration-300">
      <img src={a} alt="icon-a" className="w-[64px] h-[64px]" />
          <h4 className="text-xl font-semibold">Speed and Agility</h4>
          <p className="text-sm text-gray-700">
            Accelerate deployment and adapt quickly to market opportunities with our cloud engineering approach.
          </p>
        </div>
        <div className="flex flex-col items-center gap-4 text-center shadow-md hover:shadow-lg p-4 rounded-lg transition-shadow duration-300">
        <img src={b} alt="icon-b" className="w-[94px] h-[64px]" />
          <h4 className="text-xl font-semibold">Reliability and Performance</h4>
          <p className="text-sm text-gray-700">
            Achieve high-quality app updates and infrastructure changes using CI/CD pipelines.
          </p>
        </div>
        <div className="flex flex-col items-center gap-4 text-center shadow-md hover:shadow-lg p-4 rounded-lg transition-shadow duration-300">
        <img src={c} alt="icon-c" className="w-[64px] h-[64px]" />
          <h4 className="text-xl font-semibold">Scalability</h4>
          <p className="text-sm text-gray-700">
            Seamlessly scale infrastructure and applications to meet evolving business demands.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DevOps;
